import PropTypes from 'prop-types';
import { Grid, GridItem } from '@bwoty-web/ui-kit';
import SocialMediaLinks from './components/SocialMediaLinks';
import LinkList from './components/LinkList';
import Disclaimer from './components/Disclaimer';
import PaymentOptions from './components/PaymentOptions';
import Newsletter from './components/Newsletter';
import './footer.scss';

const FooterContainer = ({ content, imageDomain }) => {
  if (content == null) {
    return null;
  }

  return (
    <footer className="footer">
      <Grid root>
        <GridItem>
          <div className="footer-sections">
            <div className="footer-section footer-section--shortcuts">
              <h2 className="footer-section__title">{content.shortcuts.title}</h2>
              <div className="footer-link-list-container">
                <LinkList links={content.shortcuts.commonLinks} />
                <LinkList links={content.shortcuts.resortLinks} />
              </div>
            </div>
            <div className="footer-section footer-section--newsletter">
              <h2 className="footer-section__title">{content.newsletter.title}</h2>
              <div className="footer-section__intro-text">{content.newsletter.introText}</div>
              <Newsletter />
              <SocialMediaLinks links={content.newsletter.socialMediaLinks} />
              <LinkList
                links={[content.newsletter.appLink]}
                className="footer-link-list--app-link"
              />
            </div>
            <div className="footer-section footer-section--market">
              <h2 className="footer-section__title">{content.market.title}</h2>
              <div className="footer-section__intro-text">{content.market.introText}</div>
              <div className="footer-link-list-container">
                <LinkList links={content.market.linkGroup1} />
                <LinkList links={content.market.linkGroup2} />
              </div>
              {content.paymentOptions && (
                <PaymentOptions
                  imageDomain={imageDomain}
                  title={content.paymentOptions.title}
                  options={content.paymentOptions.options}
                />
              )}
            </div>
          </div>
        </GridItem>
      </Grid>
      <Disclaimer
        links={content.disclaimer.links}
        copyright={content.disclaimer.copyright}
      />
    </footer>
  );
};

FooterContainer.propTypes = {
  content: PropTypes.shape({
    shortcuts: PropTypes.shape({
      title: PropTypes.string,
      resortLinks: PropTypes.arrayOf(PropTypes.shape({})),
      commonLinks: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    newsletter: PropTypes.shape({
      title: PropTypes.string,
      introText: PropTypes.string,
      emailPlaceholder: PropTypes.string,
      submitBtnText: PropTypes.string,
      successMessage: PropTypes.string,
      invalidMessage: PropTypes.string,
      socialMediaLinks: PropTypes.arrayOf(PropTypes.shape({})),
      appLink: PropTypes.shape({}),
    }),
    market: PropTypes.shape({
      title: PropTypes.string,
      introText: PropTypes.string,
      linkGroup1: PropTypes.arrayOf(PropTypes.shape({})),
      linkGroup2: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    disclaimer: PropTypes.shape({
      copyright: PropTypes.string,
      links: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    paymentOptions: PropTypes.shape({
      title: PropTypes.string,
      options: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }).isRequired,
  imageDomain: PropTypes.string.isRequired,
};

export default FooterContainer;
